<template>
  <chart-canvas :option="option" :empty="empty" />
</template>

<script>
import ChartCanvas from "./ChartCanvas.vue";
import { colors, lineTrendOption } from "./chart-options";

export default {
  name: "UserTrendChart",
  components: { ChartCanvas },
  props: { trend: { type: Array, default: () => [] } },
  computed: {
    empty() {
      return !this.trend.some(
        (item) =>
          item.sessions !== null ||
          item.total_users !== null ||
          item.new_users !== null
      );
    },
    option() {
      return lineTrendOption(this.trend, [
        { name: "会话数", key: "sessions", color: colors.blue },
        { name: "用户总数", key: "total_users", color: colors.purple },
        { name: "新用户数", key: "new_users", color: colors.green },
      ]);
    },
  },
};
</script>
